import RoomCardBody from "../../shared/RoomCardBody/RoomCardBody"
import RoomCardHeader from "../../shared/RoomCardHeader/RoomCardHeader"
import Wrapper from "../../shared/Wrapper/Wrapper"
import { RoomStatusProps } from "../../../../interfaces/RoomStatusProps.interface"
import { useApartadaCountdown } from "../../../../hooks/useApartadaCountdown"

import "../Blocked/Blocked.css"

const Apartada = ({
    roomTypeName,
    roomNumber,
    dateStatusChanged,
    hasIncidences,
}: Omit<RoomStatusProps, "roomStatus">) => {
    const { timeLeft } = useApartadaCountdown(dateStatusChanged)

    return (
        <Wrapper bgColor={"var(--card-gray)"}>
            <RoomCardHeader
                hasIncidences={hasIncidences}
                iconBgColor="var(--bloqueada)"
                iconName="LockFill"
                roomNumber={roomNumber}
                roomTypeName={roomTypeName}
            />
            <RoomCardBody verticalAlign="center">
                <span className="room-card--mxl-blocked__gest-name">{timeLeft}</span>
                <div className="room-card--mxl-blocked__description-wrapper">
                    <span className="room-card--mxl-blocked__gest-number">Habitación apartada</span>
                </div>
            </RoomCardBody>
        </Wrapper>
    )
}

export default Apartada
